var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEqual({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83398 19.4398L8.38209 18.9612C12.9912 14.9366 15.334 11.4225 15.334 8.3335C15.334 3.95905 11.9198 0.833496 7.83398 0.833496C3.74819 0.833496 0.333984 3.95905 0.333984 8.3335C0.333984 11.4225 2.67674 14.9366 7.28588 18.9612L7.83398 19.4398ZM7.83398 17.2197C3.92283 13.6948 2.00065 10.7079 2.00065 8.3335C2.00065 4.914 4.63741 2.50016 7.83398 2.50016C11.0306 2.50016 13.6673 4.914 13.6673 8.3335C13.6673 10.7079 11.7451 13.6948 7.83398 17.2197ZM4.50065 11.6668V10.0002H11.1673V11.6668H4.50065ZM4.50065 6.66683V8.3335H11.1673V6.66683H4.50065Z",
    fill: "#8491CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqual);
export default __webpack_public_path__ + "static/media/equal.e6d334425a363eff4d60e97c85692a51.svg";
export { ForwardRef as ReactComponent };